import Link from "next/link";
import { resolveCategoryImageUrl } from "@/utils/media";
import { SafeImage } from "@/components/common/SafeImage";

const CATEGORY_PLACEHOLDER_IMAGE = "/categoryplaceholder.png";

export const SubCategoryGrid = ({ categories }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
    {categories.map((sub, i) => {
      const categoryImage = resolveCategoryImageUrl(sub);
      const usesDefaultImage = !categoryImage;
      const resolvedImage = categoryImage || CATEGORY_PLACEHOLDER_IMAGE;
      return (
        <Link
          key={sub._id || sub.id || i}
          href={`/categories/${sub.slug}`}
          className="group relative flex flex-col items-center justify-start p-4 md:p-5 bg-white rounded-lg border border-zinc-200 hover:border-blue-500/30 hover:-translate-y-1 transition-all duration-300 min-h-full"
        >
          <div className="relative mb-3 flex items-center justify-center w-20 h-20 md:w-24 md:h-24 overflow-hidden">
            <SafeImage
              src={resolvedImage}
              alt={sub.name}
              fill
              fallbackSrc={CATEGORY_PLACEHOLDER_IMAGE}
              priority={i < 4}
              fetchPriority={i < 4 ? "high" : "auto"}
              loading={i < 4 ? "eager" : "lazy"}
              className={`${usesDefaultImage ? "object-cover scale-[1.50] group-hover:scale-[1.60]" : "object-contain group-hover:scale-110"} transition-transform duration-500`}
              sizes="(max-width: 640px) 42vw, (max-width: 1024px) 24vw, 18vw"
            />
          </div>
          <h3 className="text-sm font-bold text-slate-800 text-center leading-tight group-hover:text-primary transition-colors duration-300 line-clamp-2 mb-1">
            {sub.name}
          </h3>
          {sub.productCount > 0 && (
            <span className="mt-1 px-2.5 py-0.5 rounded-full bg-slate-50 text-[10px] font-medium text-slate-500 border border-zinc-200">
              {sub.productCount} parts
            </span>
          )}
        </Link>
      );
    })}
  </div>
);
